import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { FiImage, FiPlus, FiCheckCircle } from 'react-icons/fi';

const CreateBanner = ({
    show,
    handleClose,
    loading,
    selectedBanner,
    loadOptionsProducts,
    products,
    onProductChange,
    customStyless,
    formik,
    handleWebImageChange,
    handleMobImageChange,
}) => {
    const isEdit = !!selectedBanner?.id;

    const ImageUploader = ({ label, id, viewValue, onChange, error, touched }) => {
        const invalid = touched && !!error;
        return (
            <div>
                <label className="cbn-label">{label}</label>
                <label
                    htmlFor={id}
                    className={`cbn-uploader${invalid ? ' is-invalid' : ''}${viewValue ? ' has-image' : ''}`}
                >
                    {viewValue ? (
                        <>
                            <img src={viewValue} alt={label} />
                            <div className="cbn-uploader-overlay">
                                <FiImage size={16} />
                                <span>Change image</span>
                            </div>
                        </>
                    ) : (
                        <div className="cbn-uploader-empty">
                            <span className="cbn-uploader-icon"><FiImage size={18} /></span>
                            <span className="cbn-uploader-title">Click to upload</span>
                            <span className="cbn-uploader-sub">PNG, JPG · under 2MB</span>
                        </div>
                    )}
                </label>
                <Form.Control
                    id={id}
                    type="file"
                    accept="image/*"
                    onChange={onChange}
                    isInvalid={invalid}
                    style={{ display: 'none' }}
                />
                {invalid && <div className="cbn-error">{error}</div>}
            </div>
        );
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            dialogClassName="cbn-modal"
            contentClassName="cbn-modal-content"
        >
            <style>{`
              .cbn-modal { max-width: 640px; }
              .cbn-modal-content {
                border: none !important;
                border-radius: 14px !important;
                box-shadow: 0 20px 50px rgba(15,23,42,0.18) !important;
                overflow: hidden !important;
              }
              @media (max-width: 575.98px) {
                .cbn-modal { max-width: none !important; width: calc(100vw - 16px) !important; margin: 0 auto !important; }
              }

              .cbn-modal .cbn-header {
                padding: 14px 20px !important;
                border-bottom: 1px solid #eef2f7 !important;
              }
              .cbn-modal .cbn-header .modal-title {
                font-size: 15px;
                font-weight: 700;
                color: #0f172a;
                letter-spacing: -0.01em;
              }

              .cbn-modal .cbn-body {
                padding: 18px 20px !important;
                background: #ffffff;
              }
              .cbn-modal .cbn-label {
                font-size: 11px;
                font-weight: 700;
                color: #475569;
                letter-spacing: 0.03em;
                text-transform: uppercase;
                margin: 0 0 6px;
                display: block;
              }
              .cbn-modal .cbn-input {
                border: 1px solid #e2e8f0 !important;
                border-radius: 6px !important;
                background: #fff !important;
                color: #0f172a !important;
                font-size: 12.5px !important;
                height: 36px !important;
                padding: 6px 12px !important;
                transition: border-color 0.15s ease, box-shadow 0.15s ease;
              }
              .cbn-modal .cbn-input:focus {
                border-color: #008695 !important;
                box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                outline: none;
              }

              /* Image uploader tile */
              .cbn-modal .cbn-uploader {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                aspect-ratio: 16 / 9;
                border: 2px dashed #cbd5e1;
                border-radius: 10px;
                background: linear-gradient(180deg, #fbfcfd 0%, #f4f7fa 100%);
                cursor: pointer;
                overflow: hidden;
                transition: all 0.15s ease;
              }
              .cbn-modal .cbn-uploader:hover {
                border-color: #008695;
                background: rgba(0,134,149,0.04);
              }
              .cbn-modal .cbn-uploader.has-image {
                border-style: solid;
                border-color: #e2e8f0;
                background: #f8fafc;
              }
              .cbn-modal .cbn-uploader.is-invalid { border-color: #dc2626 !important; }
              .cbn-modal .cbn-uploader img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              .cbn-modal .cbn-uploader-overlay {
                position: absolute;
                inset: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                background: rgba(15,23,42,0.55);
                color: #fff;
                opacity: 0;
                transition: opacity 0.15s ease;
                font-size: 11px;
                font-weight: 600;
                letter-spacing: 0.02em;
              }
              .cbn-modal .cbn-uploader.has-image:hover .cbn-uploader-overlay { opacity: 1; }
              .cbn-modal .cbn-uploader-empty {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                text-align: center;
                padding: 12px;
              }
              .cbn-modal .cbn-uploader-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 34px;
                height: 34px;
                border-radius: 8px;
                background: rgba(0,134,149,0.10);
                color: #008695;
                margin-bottom: 4px;
              }
              .cbn-modal .cbn-uploader-title {
                font-size: 12px;
                font-weight: 600;
                color: #0f172a;
              }
              .cbn-modal .cbn-uploader-sub {
                font-size: 10px;
                color: #94a3b8;
                font-weight: 500;
              }
              .cbn-modal .cbn-error {
                display: block;
                margin-top: 4px;
                font-size: 10.5px;
                color: #dc2626;
                font-weight: 500;
              }

              /* React-select overrides for the products picker */
              .cbn-modal .cbn-select .select__control {
                border: 1px solid #e2e8f0;
                border-radius: 6px;
                min-height: 36px;
                font-size: 12.5px;
                box-shadow: none;
              }
              .cbn-modal .cbn-select .select__control--is-focused {
                border-color: #008695;
                box-shadow: 0 0 0 3px rgba(0,134,149,0.15);
              }
              .cbn-modal .cbn-select .select__menu {
                font-size: 12px;
                border-radius: 8px;
                box-shadow: 0 8px 24px rgba(15,23,42,0.10);
              }
              .cbn-modal .cbn-select .select__option--is-focused { background-color: rgba(0,134,149,0.08); color: #0f172a; }
              .cbn-modal .cbn-select .select__option--is-selected { background-color: rgba(0,134,149,0.14); color: #0f172a; }
              .cbn-modal .cbn-select .select__placeholder { color: #94a3b8; font-size: 12px; }
              .cbn-modal .cbn-select .select__single-value { color: #0f172a; font-size: 12.5px; }

              /* Footer */
              .cbn-modal .cbn-footer {
                padding: 12px 18px !important;
                border-top: 1px solid #eef2f7 !important;
                display: flex;
                gap: 8px;
                justify-content: flex-end;
              }
              @media (max-width: 480px) {
                .cbn-modal .cbn-footer { justify-content: stretch; }
                .cbn-modal .cbn-footer .cbn-btn { flex: 1; }
              }
              .cbn-modal .cbn-btn {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                height: 38px;
                padding: 0 18px;
                border-radius: 6px;
                font-size: 12.5px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.15s ease;
                min-width: 120px;
              }
              .cbn-modal .cbn-btn:disabled { cursor: not-allowed; opacity: 0.7; }
              .cbn-modal .cbn-btn-cancel {
                background: #fff;
                border: 1px solid #e2e8f0;
                color: #0f172a;
              }
              .cbn-modal .cbn-btn-cancel:hover:not(:disabled) {
                background: #f8fafc;
                border-color: #cbd5e1;
              }
              .cbn-modal .cbn-btn-primary {
                background: #008695;
                border: 1px solid #008695;
                color: #fff;
                box-shadow: 0 3px 8px rgba(0,134,149,0.22);
              }
              .cbn-modal .cbn-btn-primary:hover:not(:disabled) {
                background: #006672;
                border-color: #006672;
              }
            `}</style>

            <Form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton className="cbn-header">
                    <Modal.Title>{isEdit ? 'Update' : 'Create'} Banner</Modal.Title>
                </Modal.Header>

                <Modal.Body className="cbn-body">
                    <div className="row gx-3 gy-3">
                        {/* Title */}
                        <div className="col-12">
                            <label className="cbn-label" htmlFor="cbn-title">Title</label>
                            <Form.Control
                                id="cbn-title"
                                type="text"
                                placeholder="Enter banner title"
                                name="title"
                                className="cbn-input"
                                value={formik.values?.title || ''}
                                onChange={formik.handleChange}
                                isInvalid={formik.touched.title && !!formik.errors.title}
                            />
                            {formik.touched.title && formik.errors.title && (
                                <div className="cbn-error">{formik.errors.title}</div>
                            )}
                        </div>

                        {/* Web + Mobile images side by side */}
                        <div className="col-6">
                            <ImageUploader
                                label="Web Image"
                                id="cbn-web-image"
                                viewValue={formik.values.webImage_view}
                                onChange={handleWebImageChange}
                                error={formik.errors.webImage}
                                touched={formik.touched.webImage}
                            />
                        </div>
                        <div className="col-6">
                            <ImageUploader
                                label="Mobile Image"
                                id="cbn-mob-image"
                                viewValue={formik.values.mobileImage_view}
                                onChange={handleMobImageChange}
                                error={formik.errors.mobileImage}
                                touched={formik.touched.mobileImage}
                            />
                        </div>

                        {/* Products */}
                        <div className="col-12">
                            <label className="cbn-label">Linked Product</label>
                            <AsyncSelect
                                className="cbn-select"
                                classNamePrefix="select"
                                loadOptions={loadOptionsProducts}
                                defaultOptions={products}
                                isClearable
                                placeholder="Search products"
                                onChange={onProductChange}
                                value={formik.values.selectedProduct}
                                styles={customStyless}
                            />
                            {formik.touched.selectedProduct && formik.errors.selectedProduct && (
                                <div className="cbn-error">{formik.errors.selectedProduct}</div>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="cbn-footer">
                    <button
                        type="button"
                        className="cbn-btn cbn-btn-cancel"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="cbn-btn cbn-btn-primary"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Saving...
                            </>
                        ) : isEdit ? (
                            <>
                                <FiCheckCircle size={14} strokeWidth={2} />
                                Update Banner
                            </>
                        ) : (
                            <>
                                <FiPlus size={14} strokeWidth={2.5} />
                                Create Banner
                            </>
                        )}
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateBanner;
